import { useState } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import useAuth from "hooks/useAuth";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import colors from "assets/theme/base/colors";
import linearGradient from "assets/theme/functions/linearGradient";
import useChatSupport from "hooks/useChatSupport";

const HelpOverview = () => {
  const axios = useAxiosPrivate();
  const { auth } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const { setOpen } = useChatSupport();

  const handleChatSupportClick = () => {
    setOpen(true);
  };

  const handleSearch = () => {};

  return (
    <Card id="compliance-overview" style={{ height: "100%" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDBox
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          shadow="lg"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="2.5rem"
          pl={2}
          pr={2}
          mt={-4}
        >
          <MDTypography variant="h6" fontWeight="medium" color="white">
            Help
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        p={3}
        style={{
          backgroundColor: colors.grey[200],
          background: linearGradient(colors.grey[200], "white", 0),
        }}
      >
        <MDBox pt={2} pb={2} fontSize="2rem" style={{ textAlign: "center", width: "100%" }}>
          Hi {auth?.profile?.firstName}, how can we help?
        </MDBox>
        <MDBox width={600} display="flex" p={1}>
          <MDInput
            placeholder="Search for help topics, tutorials and more.."
            value={searchTerm}
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
            id="search"
            fullWidth
          />
          <MDButton
            variant="gradient"
            color="primary"
            onClick={handleSearch}
            sx={{ marginLeft: 1 }}
          >
            <Icon>search</Icon>&nbsp;Search
          </MDButton>
        </MDBox>
      </MDBox>
      <MDBox display="flex" justifyContent="center" p={3}>
        <MDBox display="flex" p={1} textAlign="center" justifyContent="space-between" width={700}>
          <MDBox
            bgColor="light"
            width={200}
            height={200}
            borderRadius="xl"
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            sx={{
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: colors.grey[300],
                transform: "scale(1.05)",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
              },
            }}
          >
            <MDTypography variant="body2">
              <span style={{ fontSize: 48 }}>
                <Icon>tips_and_updates</Icon>
              </span>
              <br />
              Tutorials
            </MDTypography>
          </MDBox>
          <MDBox
            bgColor="light"
            width={200}
            height={200}
            borderRadius="xl"
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            sx={{
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: colors.grey[300],
                transform: "scale(1.05)",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
              },
            }}
          >
            <MDTypography variant="body2">
              <span style={{ fontSize: 48 }}>
                <Icon>email</Icon>
              </span>
              <br />
              Email Support
            </MDTypography>
          </MDBox>
          <MDBox
            onClick={handleChatSupportClick}
            bgColor="light"
            width={200}
            height={200}
            borderRadius="xl"
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            sx={{
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: colors.grey[300],
                transform: "scale(1.05)",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                cursor: "pointer",
              },
            }}
          >
            <MDTypography variant="body2">
              <span style={{ fontSize: 48 }}>
                <Icon>headset_mic</Icon>
              </span>
              <br />
              Chat with Support
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};
export default HelpOverview;
